<div>

    <div class="p-grid  p-px-3 p-jc-between">

        <!--Start : Booking Reference-->
        <div class="p-col-12 p-mt-3 p-lg-6 p-mb-5 p-mb-lg-0">
            <div class="p-shipment-header p-text-secondary">
                {{'BOOKING REFERENCE'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Booking Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.bookingNumber ? shipmentDetails?.bookingRef?.bookingNumber: ' - '}}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Booking DATE
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.bookingDate ? (shipmentDetails?.bookingRef?.bookingDate | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        HBL Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.hblNumber ? shipmentDetails?.bookingRef?.hblNumber : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        HBL Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.hblNumber ? shipmentDetails?.bookingRef?.hblNumber : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        MBL Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.mblNumber ? shipmentDetails?.bookingRef?.mblNumber : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Origin
                    </div>
                    <div class="p-col-6 p-py-3">
                        {{shipmentDetails?.bookingRef?.origin ? shipmentDetails?.bookingRef?.origin : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Destination
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.destination ? shipmentDetails?.bookingRef?.destination : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Customer Ref. Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.bookingRef?.customerRefNumber ? shipmentDetails?.bookingRef?.customerRefNumber : ' - ' }}
                    </div>
                </div>
            </div>
        </div>
        <!--End : Booking Reference-->

        <!--Start : Invoice  Party-->
        <div class="p-col-12 p-mt-3 p-lg-6">
            <div class="p-shipment-header p-text-secondary">
                {{'INVOICE PARTY'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Customer
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.customerName ? shipmentDetails?.involvedParty?.customerName : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Shipper
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.shipper ? shipmentDetails?.involvedParty?.shipper : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Consignee
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.consignee ? shipmentDetails?.involvedParty?.consignee : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Notify Party 1
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.notifyParty1 ? shipmentDetails?.involvedParty?.notifyParty1 : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Notify Party 2
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.notifyParty2 ? shipmentDetails?.involvedParty?.notifyParty2 : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        PickUp Transporter
                    </div>
                    <div class="p-col-6 p-py-3">
                        {{shipmentDetails?.involvedParty?.pickUpTransporter ? shipmentDetails?.involvedParty?.pickUpTransporter : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Destination Transporter
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.destinationTransporter ? shipmentDetails?.involvedParty?.destinationTransporter : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Origin Agent
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.originAgent ? shipmentDetails?.involvedParty?.originAgent : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Destination Agent
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.involvedParty?.destinationAgent ? shipmentDetails?.involvedParty?.destinationAgent : ' - ' }}
                    </div>
                </div>
            </div>
        </div>
        <!--End : Invoice  Party-->

    </div>


    <div class="p-grid p-px-3 p-mt-5 p-jc-between">

        <!--Start : Shipment Reference-->
        <div class="p-col-12 p-lg-6 p-mt-3 p-mb-5 p-mb-lg-0">
            <div class="p-shipment-header p-text-secondary">
                {{'SHIPMENT'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Terms of Shipment
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.shipment?.termsOfShipment ? shipmentDetails?.shipment?.termsOfShipment : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Carrier
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.shipment?.carrier ? shipmentDetails?.shipment?.carrier : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Freight Terms
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.shipment?.freightTerms ? shipmentDetails?.shipment?.freightTerms : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Vessel
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.shipment?.vesselName ? shipmentDetails?.shipment?.vesselName : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Voyage
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.shipment?.voyageNumber ? shipmentDetails?.shipment?.voyageNumber : ' - ' }}
                    </div>
                </div>

            </div>
        </div>
        <!--End : Shipment Reference-->

        <!--Start : Vessel  Party-->
        <div class="p-col-12 p-mt-3 p-lg-6">
            <div class="p-shipment-header p-text-secondary">
                {{'VESSEL'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Port of Loading
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.pol ? shipmentDetails?.vessel?.pol : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Port of Discharge
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.pod ? shipmentDetails?.vessel?.pod : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ETD
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.etd ? (shipmentDetails?.vessel?.etd | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ETA
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.eta ? (shipmentDetails?.vessel?.eta | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ATD
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.atd ? (shipmentDetails?.vessel?.atd | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ATA
                    </div>
                    <div class="p-col-6 p-py-3">
                        {{shipmentDetails?.vessel?.ata ? (shipmentDetails?.vessel?.ata | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Mode
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.mode ? shipmentDetails?.vessel?.mode : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Status
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.vessel?.status ? shipmentDetails?.vessel?.status : ' - ' }}
                    </div>
                </div>
            </div>
        </div>
        <!--End : Vessel  Party-->

    </div>


    <div class="p-grid p-px-3 p-mt-5 p-jc-between">



        <!--Start : Transhipment  Party-->
        <div class="p-col-12 p-lg-6 p-mt-3 p-mb-5 p-mb-lg-0">
            <div class="p-shipment-header p-text-secondary">
                {{'TRANSHIPMENT'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Connecting Vessel
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.connectingVessel ? shipmentDetails?.transhipment?.connectingVessel : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Origin
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.origin ? shipmentDetails?.transhipment?.origin : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Destination
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.destination ? shipmentDetails?.transhipment?.destination : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ETD
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.etd ? (shipmentDetails?.transhipment?.etd | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ETA
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.eta ? (shipmentDetails?.transhipment?.eta | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ATD
                    </div>
                    <div class="p-col-6 p-py-3">
                        {{shipmentDetails?.transhipment?.atd ? (shipmentDetails?.transhipment?.atd | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        ATA
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.transhipment?.ata ? (shipmentDetails?.transhipment?.ata | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>


            </div>
        </div>
        <!--End : Transhipment  Party-->

        <!--Start : Cargo-->
        <div class="p-col-12 p-mt-3 p-lg-6">
            <div class="p-shipment-header p-text-secondary">
                {{'CARGO'}}
            </div>
            <div class="card p-font-11 p-card height-100 p-text-secondary p-text-wrap">

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Commodity
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.commodity ? shipmentDetails?.cargo?.commodity : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-pb-3">
                    <div class="p-col-6 p-text-bold">
                        Container Type
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.containerType ? shipmentDetails?.cargo?.containerType + ' x ' + shipmentDetails?.cargo?.numberOfContainers : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        No. of Containers
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.numberOfContainers ? shipmentDetails?.cargo?.numberOfContainers : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Container Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.containerNumbers ? shipmentDetails?.cargo?.containerNumbers : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Seal Number
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.sealNumber ? shipmentDetails?.cargo?.sealNumber : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        External Pack
                    </div>
                    <div class="p-col-6 p-py-3">
                        {{shipmentDetails?.cargo?.externalPack ? shipmentDetails?.cargo?.externalPack : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Internal Pack
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.internalPack ? shipmentDetails?.cargo?.internalPack : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Gross Weight
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.grossWeight ? shipmentDetails?.cargo?.grossWeight : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Volume
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.volume ? shipmentDetails?.cargo?.volume : ' - ' }}
                    </div>
                </div>

                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Cargo Received Date
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.cargoReceivedDate ? shipmentDetails?.cargo?.cargoReceivedDate : ' - ' }}
                    </div>
                </div>
                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Stuffing Date
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.stuffingDate ? (shipmentDetails?.cargo?.stuffingDate | date: 'yyyy-mm-dd') : ' - ' }}
                    </div>
                </div>
                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Special Instruction
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.specialInstructions ? shipmentDetails?.cargo?.specialInstructions : ' - ' }}
                    </div>
                </div>
                <div class="p-grid p-py-3">
                    <div class="p-col-6 p-text-bold">
                        Note
                    </div>
                    <div class="p-col-6">
                        {{shipmentDetails?.cargo?.note ? shipmentDetails?.cargo?.note : ' - ' }}
                    </div>
                </div>

            </div>
        </div>
        <!--End : Cargo-->

    </div>



</div>
